module.exports = __webpack_public_path__ + "static/breedon_logo-be0011b6c329eb5a7680e39b2093d6b8.png";